 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"About~Index":"About~Index","Index":"Index","About~Institution~NewsDetail~Platform~Tech":"About~Institution~NewsDetail~Platform~Tech","NewsDetail":"NewsDetail","Platform":"Platform","Tech":"Tech","Building":"Building","DataShare":"DataShare","DownloadList":"DownloadList","IndustryPlatformDetail":"IndustryPlatformDetail","Open":"Open","Training":"Training","Topic":"Topic","TopicDetail":"TopicDetail","About~Instrument~Organ":"About~Instrument~Organ","About":"About","Institution~Zhuhai":"Institution~Zhuhai","Institution":"Institution","IndustryDetail":"IndustryDetail","Instrument":"Instrument","Organ":"Organ","ForgetPwd":"ForgetPwd","Industry":"Industry","IndustryDetailTemp~User":"IndustryDetailTemp~User","IndustryDetailTemp":"IndustryDetailTemp","IndustryPlatformList":"IndustryPlatformList","Login~Register~Zhuhai":"Login~Register~Zhuhai","Register~Zhuhai":"Register~Zhuhai","Zhuhai":"Zhuhai","Login":"Login","Register":"Register","Main":"Main","NewsListPage":"NewsListPage","TechRes":"TechRes","Zhaoqing":"Zhaoqing","User":"User"}[chunkId]||chunkId) + "." + {"About~Index":"9571cee4","Index":"a3275739","About~Institution~NewsDetail~Platform~Tech":"80574a35","NewsDetail":"a87de046","Platform":"e0421b87","Tech":"61da37f4","Building":"634cf68e","DataShare":"88dd2be7","DownloadList":"bc80a59e","IndustryPlatformDetail":"77760f5b","Open":"d252c30e","Training":"c722b7b5","chunk-7097bee7":"81891c2c","Topic":"9c5d8c16","TopicDetail":"eb1c1f79","About~Instrument~Organ":"8d4a1dd5","About":"08301d71","Institution~Zhuhai":"6eb2eafd","Institution":"4eecf067","IndustryDetail":"0f7a5c08","Instrument":"9515519e","Organ":"c721ff71","ForgetPwd":"d784f611","Industry":"9ff05900","IndustryDetailTemp~User":"034a05be","IndustryDetailTemp":"4bd5069a","IndustryPlatformList":"b4b3bf9c","Login~Register~Zhuhai":"270eaa9b","Register~Zhuhai":"0860e9bd","Zhuhai":"c4354f61","Login":"d0856353","Register":"cddaa01d","Main":"fa184d75","NewsListPage":"09881837","TechRes":"c363a332","Zhaoqing":"0b0d3990","chunk-fa13fea0":"c8dd1cdf","User":"75aa2190"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About~Index":1,"Index":1,"About~Institution~NewsDetail~Platform~Tech":1,"NewsDetail":1,"Platform":1,"Tech":1,"Building":1,"DataShare":1,"DownloadList":1,"IndustryPlatformDetail":1,"Open":1,"Training":1,"chunk-7097bee7":1,"Topic":1,"TopicDetail":1,"About~Instrument~Organ":1,"About":1,"Institution~Zhuhai":1,"Institution":1,"IndustryDetail":1,"Instrument":1,"Organ":1,"ForgetPwd":1,"Industry":1,"IndustryDetailTemp~User":1,"IndustryDetailTemp":1,"IndustryPlatformList":1,"Login~Register~Zhuhai":1,"Register~Zhuhai":1,"Zhuhai":1,"Login":1,"Register":1,"Main":1,"NewsListPage":1,"TechRes":1,"Zhaoqing":1,"chunk-fa13fea0":1,"User":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"About~Index":"About~Index","Index":"Index","About~Institution~NewsDetail~Platform~Tech":"About~Institution~NewsDetail~Platform~Tech","NewsDetail":"NewsDetail","Platform":"Platform","Tech":"Tech","Building":"Building","DataShare":"DataShare","DownloadList":"DownloadList","IndustryPlatformDetail":"IndustryPlatformDetail","Open":"Open","Training":"Training","Topic":"Topic","TopicDetail":"TopicDetail","About~Instrument~Organ":"About~Instrument~Organ","About":"About","Institution~Zhuhai":"Institution~Zhuhai","Institution":"Institution","IndustryDetail":"IndustryDetail","Instrument":"Instrument","Organ":"Organ","ForgetPwd":"ForgetPwd","Industry":"Industry","IndustryDetailTemp~User":"IndustryDetailTemp~User","IndustryDetailTemp":"IndustryDetailTemp","IndustryPlatformList":"IndustryPlatformList","Login~Register~Zhuhai":"Login~Register~Zhuhai","Register~Zhuhai":"Register~Zhuhai","Zhuhai":"Zhuhai","Login":"Login","Register":"Register","Main":"Main","NewsListPage":"NewsListPage","TechRes":"TechRes","Zhaoqing":"Zhaoqing","User":"User"}[chunkId]||chunkId) + "." + {"About~Index":"ef3f5e6f","Index":"0721ef13","About~Institution~NewsDetail~Platform~Tech":"c5098ced","NewsDetail":"91d2955d","Platform":"71914fed","Tech":"868ef651","Building":"bd029c6e","DataShare":"abb51218","DownloadList":"f60b5281","IndustryPlatformDetail":"46b173db","Open":"d06a44de","Training":"4b9e5505","chunk-7097bee7":"d9414d20","Topic":"0bea4e9d","TopicDetail":"184b8fa8","About~Instrument~Organ":"6ea69714","About":"e310f121","Institution~Zhuhai":"e6d3cedc","Institution":"d90409d5","IndustryDetail":"871f38c8","Instrument":"b2a05791","Organ":"8240b4d5","ForgetPwd":"f842fb11","Industry":"3dafd599","IndustryDetailTemp~User":"dc1c0383","IndustryDetailTemp":"fc009366","IndustryPlatformList":"26c8b75e","Login~Register~Zhuhai":"190f810f","Register~Zhuhai":"ce0fdca3","Zhuhai":"36028e34","Login":"ea102c5a","Register":"ce05a49c","Main":"18c2cc71","NewsListPage":"642453e5","TechRes":"5446b1a3","Zhaoqing":"a8be946d","chunk-fa13fea0":"e652ad27","User":"3c1e93e0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
